import DefaultNotFound from "src/components/feature/NotFound";

const NotFound = () => {
  return <DefaultNotFound />;
};

export default NotFound;
